import React, { FunctionComponent } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { useToggler } from '../../../../../../../../../utils/toggler.utils';
import { TaskCard } from '../../../../../TaskCard';
import { IBoardListTasksProps } from './types';
import { taskSimpleSelectors } from '../../../../../../../../../app/resource/task-simple/task-simple.selectors';
import { useSelectWithParams } from '../../../../../../../../../utils/selector.utils';
import { sortTasksByDate } from '../../../../../../../../../utils/task.utils';

export const BoardListTasks: FunctionComponent<IBoardListTasksProps> = ({
  activeIds,
  doneIds,
  taskTypeId,
  meetingId,
}) => {
  const [show, handleShow] = useToggler(false);

  const activeTasks = useSelectWithParams(taskSimpleSelectors.selectResourcesById, activeIds);
  const doneTasks = useSelectWithParams(taskSimpleSelectors.selectResourcesById, doneIds);
  const sortedDoneTasks = sortTasksByDate(doneTasks, 'completedAt', 'DES');

  return (
    <div className="todo-container tabs">
      <Droppable droppableId={`active-${taskTypeId}`} type="task">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {activeTasks.map(
              (task, index) =>
                task && (
                  <Draggable key={`active-${task.id}`} draggableId={task.id} index={index}>
                    {(provided) => <TaskCard task={task} provided={provided} meetingId={meetingId ?? ''} />}
                  </Draggable>
                ),
            )}
            {!activeIds.length && <div style={{ height: '20px' }}></div>}
            {provided.placeholder}
          </div>
        )}
      </Droppable>

      <div className="hidden_cards_container">
        <span className="card-separator hide-cards" onClick={handleShow}>
          <span className="completed_text">
            {show ? `HIDE COMPLETED (${doneIds.length})` : `SHOW COMPLETED (${doneIds.length})`}
          </span>
        </span>
        {show && (
          <Droppable droppableId={`done-${taskTypeId}`} type="task">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {sortedDoneTasks.map(
                  (task, index) =>
                    task && (
                      <Draggable key={`done-${task.id}`} draggableId={task.id} index={index}>
                        {(provided) => {
                          return <TaskCard task={task} provided={provided} meetingId="" />;
                        }}
                      </Draggable>
                    ),
                )}
                {!doneIds.length && <div style={{ height: '20px' }}></div>}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        )}
      </div>
    </div>
  );
};
